import React, { Fragment, useMemo } from 'react'
import OrbitalInsightDetails from '../../../../../CommonComponents/orbital-insights/OrbitalInsightDetails'
import useAssets from '../../../hooks/useAssets'
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite'
import useReportWindow from '../../../hooks/useReportWindow'
import { REPORT_WINDOWS } from '../../../utils/constants'
import { ModalModeType } from '../../../../../CommonComponents/modals/Modal'
import { WindowKeys } from '../../../utils/scenario-types'

const AllOrbitalInsightsDetails = () => {

    const { orbitalInsights, orbitStartOption } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()
    const { windowStore, onReportModalChange } = useReportWindow()

    const orbitReport = useMemo(() => windowStore.modals.orbitReport, [windowStore.modals.orbitReport])
    const exposureWindows = useMemo(() => orbitReport.windows.exposure, [orbitReport.windows.exposure])
    const contactsWindows = useMemo(() => orbitReport.windows.contacts, [orbitReport.windows.contacts])
    const featuresWindows = useMemo(() => orbitReport.windows.features, [orbitReport.windows.features])

    const exposureIcon = useMemo(() => REPORT_WINDOWS.orbitReport.tabs.find(tab => tab.value === 'exposure')?.icon, [REPORT_WINDOWS])
    const activeExposure = useMemo(() => exposureWindows.open && exposureWindows.detached, [exposureWindows])
    const pinnedExposure = useMemo(() => activeExposure && exposureWindows.pinned, [activeExposure, exposureWindows])


    const contactIcon = useMemo(() => REPORT_WINDOWS.orbitReport.tabs.find(tab => tab.value === 'contacts')?.icon, [REPORT_WINDOWS])
    const activeContact = useMemo(() => contactsWindows.open && contactsWindows.detached, [contactsWindows])
    const pinnedContact = useMemo(() => activeContact && contactsWindows.pinned, [activeContact, contactsWindows])

    const featureIcon = useMemo(() => REPORT_WINDOWS.orbitReport.tabs.find(tab => tab.value === 'features')?.icon, [REPORT_WINDOWS])
    const activeFeature = useMemo(() => featuresWindows.open && featuresWindows.detached, [featuresWindows])
    const pinnedFeature = useMemo(() => activeFeature && featuresWindows.pinned, [activeFeature, featuresWindows])

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const selectedOrbitalInsights = useMemo(() => (selectedSatellite && orbitalInsights?.data) ? orbitalInsights?.data[selectedSatellite] : null, [orbitalInsights.data, selectedSatellite])

    const onModeClick = (e: React.MouseEvent, mode: ModalModeType, windowKey: WindowKeys) => {
        onReportModalChange(e, 'child', 'orbitReport', mode, windowKey)
    }

    return (
        <Fragment>
            <OrbitalInsightDetails
                icon={exposureIcon}
                title='Exposure'
                modalId='exposure'
                open={activeExposure}
                pinned={pinnedExposure}
                windowSize={exposureWindows.windowSize}
                data={selectedOrbitalInsights}
                targetId='orbital__insights__report__button'
                className='scenario__orbital__insights__modal'
                orbitStartOption={orbitStartOption}
                position={exposureWindows.position}
                zIndex={exposureWindows.zIndex}
                onModeClick={(e: React.MouseEvent, mode: ModalModeType) => { onModeClick(e, mode, 'exposure') }}
            />
            <OrbitalInsightDetails
                icon={contactIcon}
                title='Ground Contacts'
                modalId='contacts'
                open={activeContact}
                pinned={pinnedContact}
                windowSize={contactsWindows.windowSize}
                data={selectedOrbitalInsights}
                targetId='orbital__insights__report__button'
                className='scenario__orbital__insights__modal'
                orbitStartOption={orbitStartOption}
                position={contactsWindows.position}
                zIndex={contactsWindows.zIndex}
                onModeClick={(e: React.MouseEvent, mode: ModalModeType) => { onModeClick(e, mode, 'contacts') }}
            />
            <OrbitalInsightDetails
                icon={featureIcon}
                title='GeoFeatures'
                modalId='features'
                targetId='orbital__insights__report__button'
                className='scenario__orbital__insights__modal'
                open={activeFeature}
                pinned={pinnedFeature}
                windowSize={featuresWindows.windowSize}
                data={selectedOrbitalInsights}
                orbitStartOption={orbitStartOption}
                position={featuresWindows.position}
                zIndex={featuresWindows.zIndex}
                onModeClick={(e: React.MouseEvent, mode: ModalModeType) => { onModeClick(e, mode, 'features') }}
            />
        </Fragment>
    )
}

export default AllOrbitalInsightsDetails